import React, { useState, useEffect } from 'react';
import styles from '@/common/Layout/index.module.less';
import {
  Row,
  Col,
  Card,
  Radio,
  Space,
  Input,
  Form,
  message,
  Select,
  DatePicker,
  Timeline
} from 'antd';
import {
  ClockCircleOutlined,
  EditOutlined,
  QrcodeOutlined
} from '@ant-design/icons';
import Layout from '@/common/Layout';
import { useDispatch } from 'react-redux';
import {
  createEqpLogBooks,
  getAllEqpLogBooksdetails,
  updateEqpLogBooks,
  // updateQCLogBooks,
  getProdQaComments
} from '../../redux/slice';
import { getProductBatches } from '@/features/productionLabelGen/redux/slice';
import { getContainers } from '../../redux/api';
import { QrScanSingleShotModal } from '@/common/QrScan';
import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import { useLocation } from 'react-router-dom';
import { getLoggedInUser } from 'utilities/helpers';
import { history } from '@/app/history';
import moment from 'moment';
import CustomModal from '@/common/CustomModal';

const { TextArea } = Input;
const EquipmentLogBooks = () => {
  const dispatch = useDispatch();
  const [form1] = Form.useForm(); // First card form
  const [form2] = Form.useForm(); // Second card form
  const [verificationForm] = Form.useForm();
  const [openCam, setOpenCam] = useState(false);
  const [activitiId, setActivitiId] = useState('');
  // isCompression now means "WIP-only" (Compression or Inspection) for rendering;
  // logType disambiguates which flag to persist on submit.
  const [isCompression, setIsCompression] = useState();
  const [logType, setLogType] = useState('');
  const [productsData, setProductsData] = useState([]);
  const [search, setSearch] = useState('');
  const [alllog, setAlllog] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  // const [qcComments] = useState('');
  const [podComments, setPodComments] = useState([]);
  const [showmodal, setShowmodal] = useState(false);

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const logBookId = searchParams.get('id');
  const type = searchParams.get('type'); // Get type parameter
  const { user } = getLoggedInUser();

  useEffect(() => {
    handleGetProductBatches();
    if (logBookId) {
      handleGetAllLogDetails();
      setIsEditMode(false); // Initially in view mode
    }
  }, [search]);

  console.log(podComments);
  const activities = [
    {
      id: 1,
      name: 'Operation'
    },
    {
      id: 2,
      name: 'Cleaning'
    },
    {
      id: 3,
      name: 'Maintanance'
    }
  ];

  const onSearch = (e) => {
    console.log(e);
    setSearch(e);
  };

  const handleGetProductBatches = () => {
    const payload = { search };
    dispatch(getProductBatches(payload)).then((res) => {
      if (res.payload.success) {
        setProductsData(res.payload.data);
      }
    });
  };

  const handleGetComments = () => {
    const payload = { id: logBookId };
    dispatch(getProdQaComments(payload)).then((res) => {
      if (res.payload.success) {
        setPodComments(res.payload.data);
        setShowmodal(true);
      }
    });
  };
  const handleGetAllLogDetails = () => {
    const payload = { id: searchParams.get('id') };
    dispatch(getAllEqpLogBooksdetails(payload)).then((response) => {
      if (response?.payload?.success) {
        setAlllog(response?.payload?.data);
        setActivitiId(
          response?.payload?.data?.[0]?.eqp_log_type === 'Operation'
            ? 1
            : response?.payload?.data?.[0]?.eqp_log_type === 'Maintanance'
            ? 3
            : 2
        );
        const _log_type = response?.payload?.data?.[0]?.is_inspection
          ? 'inspection'
          : response?.payload?.data?.[0]?.is_compression
          ? 'compression'
          : 'normal';
        setLogType(_log_type);
        setIsCompression(
          response?.payload?.data?.[0]?.is_compression === true ||
            response?.payload?.data?.[0]?.is_inspection === true
        );

        // Set values for first card form
        form1.setFieldsValue({
          log_type: _log_type,
          product_batch: response?.payload?.data?.[0]?.product_batch || 'NA',
          product_name:
            response?.payload?.data?.[0]?.product_name ||
            response?.payload?.data?.[0]?.eqp_activity,
          equipment_id: response?.payload?.data?.[0]?.equipment_id,
          lot_no: response?.payload?.data?.[0]?.lot_no || 'NA'
        });

        // Set values for second card form
        form2.setFieldsValue({
          started_by_user_id: response?.payload?.data?.[0]?.start_user,
          start_date: response?.payload?.data?.[0]?.start_date
            ? moment(response?.payload?.data?.[0]?.start_date)
            : null,
          stoped_by_user_id: response?.payload?.data?.[0]?.end_user,
          end_date: response?.payload?.data?.[0]?.end_date
            ? moment(response?.payload?.data?.[0]?.end_date)
            : null,
          approved_remarks: response?.payload?.data?.[0]?.qa_remarks,
          prod_comments: response?.payload?.data?.[0]?.prod_comments
        });

        // Fetch area name if equipment_id exists
        if (response?.payload?.data?.[0]?.equipment_id) {
          handleGetAreaName(response?.payload?.data?.[0]?.equipment_id);
        }
      }
    });
  };

  // const handleSubmitApprove = (qcstatus) => {
  //   const payload = {
  //     id: logBookId,
  //     status: qcstatus,
  //     comments: qcComments
  //   };

  //   dispatch(updateQCLogBooks(payload)).then((res) => {
  //     if (res?.payload?.success) {
  //       verificationForm.resetFields();
  //       history.push(`/equipment-log-book-list?type=${type}`);
  //       message.success(res?.payload?.message);
  //     }
  //   });
  // };
  const onFinish = (values) => {
    // Merge values from both forms
    // const form1Values = form1.getFieldsValue();
    const form2Values = form2.getFieldsValue();
    const allValues = { ...form2Values, ...values };

    console.log(allValues);
    allValues['eqp_log_type'] =
      activitiId === 1
        ? 'operation'
        : activitiId === 2
        ? 'cleaning'
        : 'maintanance';
    allValues['dispensing_request_id'] =
      activitiId === 1 && logType === 'normal'
        ? allValues['product_batch']
        : '';
    allValues['is_compression'] = logType === 'compression';
    allValues['is_inspection'] = logType === 'inspection';

    // Format dates to "YYYY-MM-DD HH:mm:ss" format
    if (allValues['start_date']) {
      allValues['start_date'] = moment(allValues['start_date']).format(
        'YYYY-MM-DD HH:mm:ss'
      );
    }
    if (allValues['end_date']) {
      allValues['end_date'] = moment(allValues['end_date']).format(
        'YYYY-MM-DD HH:mm:ss'
      );
    }

    // Add ID to payload if in edit mode
    if (logBookId) {
      allValues['id'] = logBookId;
      type !== 'ratification' ? (allValues['type'] = 'start') : '';
    }

    if (user?.role === 'qc_initiator') {
      dispatch(updateEqpLogBooks(allValues)).then((res) => {
        if (res?.payload?.success) {
          verificationForm.resetFields();
          logBookId && type === 'ratification'
            ? history.push('/equipment-log-book-list?type=ratification')
            : history.push('/equipment-log-book-list');
          message.success(res?.payload?.message);
        }
      });
    } else {
      dispatch(createEqpLogBooks(allValues)).then((res) => {
        if (res?.payload?.success) {
          verificationForm.resetFields();
          logBookId && type === 'ratification'
            ? history.push('/equipment-log-book-list?type=ratification')
            : history.push('/equipment-log-book-list');
          message.success(res?.payload?.message);
        }
      });
    }
  };

  const handleSubmitClick = async () => {
    try {
      // Validate both forms
      await form1.validateFields();
      // await form2.validateFields();

      // Get values from both forms
      const form1Values = form1.getFieldsValue();
      // const form2Values = form2.getFieldsValue();
      const allValues = { ...form1Values };
      allValues['eqp_log_type'] =
        activitiId === 1
          ? 'operation'
          : activitiId === 2
          ? 'cleaning'
          : 'maintanance';
      allValues['dispensing_request_id'] =
        activitiId === 1 && logType === 'normal'
          ? allValues['product_batch']
          : '';
      allValues['is_compression'] = logType === 'compression';
      allValues['is_inspection'] = logType === 'inspection';
      dispatch(createEqpLogBooks(allValues)).then((res) => {
        if (res?.payload?.success) {
          verificationForm.resetFields();
          history.push('/equipment-log-book-list');
          message.success(res?.payload?.message);
        }
      });
      // Call onFinish with merged values
      // onFinish(allValues);
    } catch (error) {
      console.error('Validation failed:', error);
      message.error('Please fill all required fields');
    }
  };

  // const handleUpdateClick = () => {

  //   const form1Values = form1.getFieldsValue();
  //   const form2Values = form2.getFieldsValue();
  //   const formValues = { ...form1Values, ...form2Values };
  //   onFinish(formValues);
  // };

  const handleUpdateClick = async () => {
    try {
      // Validate only form2 before updating
      await form2.validateFields();

      // Get values from both forms after validation passes
      const form1Values = form1.getFieldsValue();
      const form2Values = form2.getFieldsValue();
      const formValues = { ...form1Values, ...form2Values };

      // Call onFinish with merged values
      onFinish(formValues);
    } catch (error) {
      console.error('Validation failed:', error);
      message.error('Please fill all required fields');
    }
  };

  const updateActivity = () => {
    const payload = { type: 'end', id: searchParams.get('id') };
    dispatch(createEqpLogBooks(payload)).then((res) => {
      if (res?.payload?.success) {
        history.push('/equipment-log-book-list');
        message.success(res?.payload?.message);
      }
    });
  };

  console.log(alllog);

  const onChangeLabel = (value) => {
    setLogType(value);
    // Compression and Inspection are both WIP-only (no DR, free-text batch).
    setIsCompression(value !== 'normal');
    form1.resetFields(['product_batch', 'product_name', 'equipment_id']);
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      console.log(scanData);
      const equipmentId = scanData.text;
      form1.setFieldsValue({ equipment_id: equipmentId });
      setOpenCam(false);

      // Call API to get area name
      await handleGetAreaName(equipmentId);
    }
  };

  const handleGetAreaName = async (equipmentId) => {
    if (equipmentId) {
      const payload = { equipment_id: equipmentId };
      try {
        const response = await getContainers(
          'get-equipment-or-area-name',
          payload
        );
        if (response?.success) {
          const areaNameValue = response?.data.name || '';
          form1.setFieldsValue({ name: areaNameValue });
        }
      } catch (error) {
        console.error('Error fetching area name:', error);
      }
    }
  };

  const onChange = (data) => {
    setActivitiId(data.target.value);
    form1.resetFields();
    form2.resetFields();
    data.target.value !== 1
      ? form1.setFieldsValue({ product_batch: 'NA' })
      : '';
  };

  const onChangeBatch = (e) => {
    const product_name = productsData?.filter((product) => product.id === e);
    console.log(product_name);
    form1?.setFieldsValue({
      product_name: product_name?.[0]?.product_detail?.name
    });
  };

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  // Determine if we should show edit button or start/stop buttons
  const isRatification = type === 'ratification';

  return (
    <>
      <Layout sider={false}>
        {/* First Card - Basic Information */}
        <Form form={form1} layout="vertical">
          <Card
            className={`${styles.cardStyles_approver}`}
            title={`Equipment usage and cleaning log book`}
            style={{ marginBottom: '24px' }}
          >
            <>
              <Space>
                <Radio.Group
                  onChange={onChange}
                  value={activitiId}
                  disabled={!!logBookId}
                >
                  {activities?.map((activity, index) => {
                    return (
                      <Radio value={activity?.id} key={index}>
                        {activity?.name}
                      </Radio>
                    );
                  })}
                </Radio.Group>
              </Space>
              <br />
              <br />
            </>

            {activitiId === 1 && (
              <Row gutter={24}>
                <Col span={8}>
                  <FormItem
                    label="Activity Type"
                    name="log_type"
                    rules={[
                      {
                        required: true,
                        message: 'Select activity type'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Select
                      placeholder="Select activity type"
                      onChange={onChangeLabel}
                      disabled={!!logBookId}
                    >
                      <Select.Option value="normal">Others</Select.Option>
                      <Select.Option value="compression">
                        Compression
                      </Select.Option>
                      <Select.Option value="inspection">
                        Inspection
                      </Select.Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            )}

            {activitiId !== '' && (
              <>
                <Row gutter={24}>
                  <Col span={6}>
                    <FormItem
                      label="Batch #"
                      name="product_batch"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      {!isCompression && activitiId === 1 ? (
                        <Select
                          placeholder="Select Product Batch"
                          showSearch
                          optionFilterProp="children"
                          onChange={onChangeBatch}
                          onSearch={onSearch}
                          disabled={!!logBookId}
                        >
                          {productsData?.map((category, index) => {
                            const processName =
                              category?.prod_label_process_master
                                ?.process_label_name;
                            const subProcessName =
                              category?.prod_label_sub_process
                                ?.sub_process_name;
                            const suffix =
                              processName || subProcessName
                                ? ` (${processName || 'NA'}${
                                    subProcessName ? ` › ${subProcessName}` : ''
                                  })`
                                : '';
                            return (
                              <option value={category?.id} key={index}>
                                {category?.product_batch_number}
                                {suffix}
                              </option>
                            );
                          })}
                        </Select>
                      ) : (
                        <Input
                          placeholder="Enter batch #"
                          disabled={!!logBookId}
                        />
                      )}
                    </FormItem>
                  </Col>

                  <Col span={6}>
                    <FormItem
                      label={
                        activitiId === 2 || activitiId === 3
                          ? 'Activity'
                          : 'Product name'
                      }
                      name="product_name"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      {activitiId === 2 ? (
                        <Select
                          placeholder="Select the activity"
                          disabled={logBookId ? !isEditMode : false}
                        >
                          <option value="Type-A">Type-A</option>
                          <option value="Type-C">Type-C</option>
                        </Select>
                      ) : activitiId === 3 ? (
                        <Select
                          placeholder="Select the activity"
                          disabled={logBookId ? !isEditMode : false}
                        >
                          <option value="PMP">PMP</option>
                          <option value="Breakdown">Breakdown</option>
                        </Select>
                      ) : (
                        <Input
                          placeholder=""
                          disabled={!isCompression || !!logBookId}
                        />
                      )}
                    </FormItem>
                  </Col>

                  <Col span={1}>
                    <CustomButton
                      className={styles.qrcode}
                      onClick={() => setOpenCam(true)}
                      style={{ marginTop: '24px' }}
                      disabled={!!logBookId}
                    >
                      <QrcodeOutlined />
                    </CustomButton>
                  </Col>

                  <Col span={5}>
                    <FormItem
                      label="Equipment ID"
                      name="equipment_id"
                      rules={[
                        {
                          required: true,
                          message: 'Select Equipment ID'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input placeholder="" disabled />
                    </FormItem>
                  </Col>

                  <Col span={6}>
                    <FormItem
                      label="Name"
                      name="name"
                      rules={[
                        {
                          required: false,
                          message: 'Area Name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input placeholder="" disabled />
                    </FormItem>
                  </Col>
                </Row>

                {activitiId === 1 && (
                  <Row gutter={24}>
                    <Col span={6}>
                      <FormItem
                        label="Lot number"
                        name="lot_no"
                        rules={[
                          {
                            required: true,
                            message: 'Select Lot number'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Select
                          placeholder="Select Lot number"
                          showSearch
                          disabled={!!logBookId}
                        >
                          {Array.from({ length: 11 }, (_, i) => i).map((i) => {
                            return (
                              <option value={i} key={i}>
                                {i == 0 ? 'NA' : `Lot ${i}`}
                              </option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                )}
                {/* Initiation approval comments removed — create now auto-starts (no QA approval).
                {user?.role === 'qc_initiator' && type === 'initiation' && (
                  <Col span={12}>
                    <FormItem
                      label="Comments"
                      rules={[
                        {
                          required: true,
                          message: 'Enter comments'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <TextArea
                        placeholder="Enter comments"
                        onChange={(e) => setQcComments(e.target.value)}
                      />
                    </FormItem>
                  </Col>
                )}
                */}
                {/* QA initiation comment display + its Back button removed — initiation approval flow decommissioned.
                {alllog?.length > 0 &&
                  alllog?.[0]?.qa_initite_comment !== null && (
                    <Col span={12}>
                      <FormItem
                        label="Comments"
                        rules={[
                          {
                            required: true,
                            message: 'Enter comments'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <TextArea
                          placeholder="Enter comments"
                          value={alllog?.[0]?.qa_initite_comment}
                          disabled
                        />
                      </FormItem>
                    </Col>
                  )}
                {alllog?.length > 0 &&
                  alllog?.[0]?.qa_initite_comment !== null && (
                    <FormItem className="text-center">
                      <CustomButton
                        className={styles.inwardButton}
                        onClick={() => history.back()}
                        type="primary"
                      >
                        Back
                      </CustomButton>
                    </FormItem>
                  )}
                */}
                {logBookId === null && (
                  <FormItem className="text-center">
                    <Space>
                      {!isRatification && user?.role !== 'qc_initiator' && (
                        <>
                          <CustomButton
                            className={styles.inwardButton}
                            type="primary"
                            onClick={handleSubmitClick}
                            disabled={
                              alllog.length
                                ? alllog?.[0]?.start_date !== null
                                  ? true
                                  : false
                                : false
                            }
                          >
                            Start
                          </CustomButton>
                        </>
                      )}
                    </Space>
                  </FormItem>
                )}
                {/* Initiation approve/reject removed — create now auto-starts (no QA approval).
                {user?.role === 'qc_initiator' && type === 'initiation' && (
                  <FormItem className="text-center">
                    <Space>
                      <CustomButton
                        className={styles.inwardButton}
                        onClick={() => history.back()}
                        type="primary"
                        ghost
                      >
                        Back
                      </CustomButton>
                      <>
                        <CustomButton
                          className={styles.inwardButton_approve}
                          type="primary"
                          onClick={() => handleSubmitApprove('Approved')}
                          disabled={
                            alllog.length
                              ? alllog?.[0]?.start_date !== null
                                ? true
                                : false
                              : false
                          }
                        >
                          Approve
                        </CustomButton>
                        <CustomButton
                          className={styles.inwardButton_reject}
                          type="error"
                          onClick={() => handleSubmitApprove('Rejected')}
                          disabled={
                            alllog.length
                              ? alllog?.[0]?.start_date !== null
                                ? true
                                : false
                              : false
                          }
                        >
                          Reject
                        </CustomButton>
                      </>
                    </Space>
                  </FormItem>
                )}
                */}
              </>
            )}
          </Card>
        </Form>

        {/* Second Card - User and Date Information with Edit button */}
        {type !== 'initiation' &&
          logBookId &&
          activitiId !== '' &&
          alllog?.[0]?.status !== 'Rejected' && (
            <Form form={form2} layout="vertical" onFinish={onFinish}>
              <Card
                className={`${styles.cardStyles_approver}`}
                title="Activity Details"
                extra={
                  <Space>
                    <ClockCircleOutlined
                      onClick={handleGetComments}
                      style={{ fontSize: '18px', cursor: 'pointer' }}
                    />
                    {logBookId &&
                    !isEditMode &&
                    isRatification &&
                    user?.role !== 'qc_initiator' &&
                    alllog?.[0]?.status !== 'initiated' &&
                    alllog?.[0]?.status !== 'Approved' ? (
                      <EditOutlined
                        onClick={handleEditClick}
                        style={{ fontSize: '18px', cursor: 'pointer' }}
                      />
                    ) : null}
                  </Space>
                }
              >
                <Row gutter={24}>
                  {/* Lot moved to the "Equipment usage and cleaning log book" card (selected before Start).
                  {activitiId === 1 && (
                    <Col span={6}>
                      <FormItem
                        label="Lot number"
                        name="lot_no"
                        rules={[
                          {
                            required: true,
                            message: 'Select Lot number'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Select
                          placeholder="Select Lot number"
                          showSearch
                          disabled={
                            alllog.length
                              ? alllog?.[0]?.start_date !== null ||
                                alllog?.[0]?.status === 'initiated'
                                ? true
                                : false
                              : false
                          }
                        >
                          {Array.from({ length: 11 }, (_, i) => i).map((i) => {
                            return (
                              <option value={i} key={i}>
                                {i == 0 ? 'NA' : `Lot ${i}`}
                              </option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </Col>
                  )}
                  */}
                  <Col span={6}>
                    <FormItem
                      label="Started by user ID"
                      name="started_by_user_id"
                      rules={[
                        {
                          required: false,
                          message: 'Select Product name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input placeholder="" disabled />
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      label="Start Date & Time"
                      name="start_date"
                      rules={[
                        {
                          required: false,
                          message: 'Select Start Date & Time'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <DatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        style={{ width: '100%' }}
                        disabled={logBookId ? !isEditMode : true}
                        placeholder="Select Start Date & Time"
                      />
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      label="Stopped by user ID"
                      name="stoped_by_user_id"
                      rules={[
                        {
                          required: false,
                          message: 'Select Product name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input placeholder="" disabled />
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      label="Stop Date & Time"
                      name="end_date"
                      rules={[
                        {
                          required: false,
                          message: 'Select Stop Date & Time'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <DatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        style={{ width: '100%' }}
                        disabled={
                          logBookId
                            ? alllog?.[0]?.end_date == null
                              ? true
                              : !isEditMode
                            : true
                        }
                        placeholder="Select Stop Date & Time"
                      />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={24}>
                  {user?.role === 'qc_initiator' ? (
                    <Col span={12}>
                      <FormItem
                        label="QA Comments"
                        name="approved_remarks"
                        rules={[
                          {
                            required: true,
                            message: 'Enter comments'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <TextArea placeholder="Enter comments" />
                      </FormItem>
                    </Col>
                  ) : (
                    alllog?.length > 0 &&
                    alllog?.[0]?.qa_remarks !== null && (
                      <Col span={12}>
                        <FormItem
                          label="QA Comments"
                          // name="approved_remarks"
                          rules={[
                            {
                              required: true,
                              message: 'Enter comments'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          <TextArea
                            placeholder="Enter comments"
                            disabled={alllog?.[0]?.qa_remarks !== ''}
                            value={alllog?.[0]?.qa_remarks}
                          />
                        </FormItem>
                      </Col>
                    )
                  )}
                  {user?.role === 'prod_ebmr' && type === 'ratification' ? (
                    <Col span={12}>
                      <FormItem
                        label="Prod Comments"
                        name="prod_comments"
                        rules={[
                          {
                            required: true,
                            message: 'Enter comments'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <TextArea placeholder="Enter comments" />
                      </FormItem>
                    </Col>
                  ) : (
                    alllog?.length > 0 &&
                    alllog?.[0]?.prod_remarks !== null &&
                    type === 'ratification' && (
                      <Col span={12}>
                        <FormItem
                          label="Prod Comments"
                          // name="prod_comments"
                          rules={[
                            {
                              required: false,
                              message: 'Enter comments'
                            }
                          ]}
                          className={styles.customLable}
                        >
                          <TextArea
                            placeholder="Enter comments"
                            value={alllog?.[0]?.prod_comments}
                            disabled={alllog?.[0]?.prod_comments !== ''}
                          />
                        </FormItem>
                      </Col>
                    )
                  )}
                </Row>

                {/* Back, Start, Stop Buttons */}
                <FormItem className="text-center">
                  <Space>
                    {!isRatification && user?.role !== 'qc_initiator' && (
                      <>
                        <CustomButton
                          className={styles.inwardButton}
                          onClick={() => history.back()}
                          type="primary"
                        >
                          Back
                        </CustomButton>
                        <CustomButton
                          className={styles.inwardButton}
                          type="primary"
                          htmlType="submit"
                          disabled={
                            alllog.length
                              ? alllog?.[0]?.start_date !== null
                                ? true
                                : false
                              : false
                          }
                        >
                          Start
                        </CustomButton>
                        <CustomButton
                          className={styles.inwardButton}
                          onClick={updateActivity}
                          type="primary"
                          disabled={
                            alllog?.[0]?.start_date !== '' &&
                            alllog?.[0]?.start_date !== null &&
                            alllog?.[0]?.end_date === null
                              ? false
                              : true
                          }
                        >
                          Stop
                        </CustomButton>
                      </>
                    )}
                  </Space>
                </FormItem>

                {/* Update/Approved Button for Second Card */}
                {(isRatification || user?.role === 'qc_initiator') && (
                  <FormItem className="text-center">
                    <Space>
                      {isRatification && logBookId && isEditMode ? (
                        <CustomButton
                          className={styles.inwardButton}
                          type="primary"
                          onClick={handleUpdateClick}
                          disabled={alllog?.[0]?.status === 'initiated'}
                        >
                          Update
                        </CustomButton>
                      ) : user?.role === 'qc_initiator' ? (
                        <CustomButton
                          className={styles.inwardButton}
                          type="primary"
                          htmlType="submit"
                        >
                          Approve
                        </CustomButton>
                      ) : null}
                    </Space>
                  </FormItem>
                )}
              </Card>
            </Form>
          )}

        <QrScanSingleShotModal
          title="Scan Equipment QR"
          visible={openCam}
          onCancel={() => setOpenCam(false)}
          hint="Point the camera at the equipment QR code."
          onScan={(decodedText) => handleQrScan({ text: decodedText })}
        />

        {showmodal ? (
          <CustomModal
            title="Activity Comments"
            visible={showmodal}
            width={'50%'}
            footer={null}
            className={styles.customModal}
            closable={false}
            onCancel={() => setShowmodal(false)}
          >
            <br />
            <Timeline mode="alternate">
              {podComments.map((comment) => {
                // Create an array to hold timeline items for this comment
                const timelineItems = [];

                // First timeline item - Production (Initiated by)
                if (comment.prod_comments) {
                  timelineItems.push(
                    <Timeline.Item
                      key={`prod-${comment.id}`}
                      color="blue"
                      icon={
                        <ClockCircleOutlined style={{ fontSize: '16px' }} />
                      }
                    >
                      <div>
                        <div style={{ marginBottom: '4px' }}>
                          <strong>Initiated by: {comment.initiated_by}</strong>
                          <span
                            style={{
                              marginLeft: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}
                          >
                            (Production E-BMR)
                          </span>
                        </div>
                        <div style={{ marginBottom: '4px', color: '#333' }}>
                          {comment.prod_comments} {'('}
                          {comment.start_date_from
                            ? moment(comment.start_date_from).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )
                            : moment(comment.end_date_from).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )}
                          {')'}
                        </div>
                        {/* {(comment.start_date_from || comment.end_date_from) && (
                          <div style={{ color: '#999', fontSize: '12px' }}>
                            {comment.start_date_from && (
                              <div>
                                Start Date: {moment(comment.start_date_from).format('YYYY-MM-DD HH:mm:ss')}
                                {comment.start_date_to && (
                                  <span> → {moment(comment.start_date_to).format('YYYY-MM-DD HH:mm:ss')}</span>
                                )}
                              </div>
                            )}
                            {comment.end_date_from && (
                              <div>
                                End Date: {moment(comment.end_date_from).format('YYYY-MM-DD HH:mm:ss')}
                                {comment.end_date_to && (
                                  <span> → {moment(comment.end_date_to).format('YYYY-MM-DD HH:mm:ss')}</span>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        <div style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}>
                          Created: {moment(comment.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                        </div> */}
                      </div>
                    </Timeline.Item>
                  );
                }

                // Second timeline item - QA Approval (Approved by)
                if (comment.approved_remarks) {
                  timelineItems.push(
                    <Timeline.Item
                      key={`qa-${comment.id}`}
                      color="green"
                      icon={
                        <ClockCircleOutlined style={{ fontSize: '16px' }} />
                      }
                    >
                      <div>
                        <div style={{ marginBottom: '4px' }}>
                          <strong>Approved by: {comment.approved_by}</strong>
                          <span
                            style={{
                              marginLeft: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}
                          >
                            (QA Approver)
                          </span>
                        </div>
                        <div style={{ marginBottom: '4px', color: '#333' }}>
                          {comment.approved_remarks} {'('}
                          {moment(comment.approved_date).format(
                            'YYYY-MM-DD HH:mm:ss'
                          )}
                          {')'}
                        </div>
                        {/* {comment.approved_date && (
                          <div style={{ color: '#999', fontSize: '12px' }}>
                            Approved: {moment(comment.approved_date).format('YYYY-MM-DD HH:mm:ss')}
                          </div>
                        )}
                        <div
                          style={{
                            marginTop: '8px',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            backgroundColor: '#f6ffed',
                            border: '1px solid #b7eb8f',
                            display: 'inline-block'
                          }}
                        >
                          Approved
                        </div> */}
                      </div>
                    </Timeline.Item>
                  );
                }

                return timelineItems;
              })}
            </Timeline>
          </CustomModal>
        ) : (
          ''
        )}
      </Layout>
    </>
  );
};

export default EquipmentLogBooks;
